import { FC, ReactNode, useEffect, useState } from "react";
import "./index.scss";
import { observer } from "mobx-react";

const SJLayout: FC<{ header?: ReactNode; children: ReactNode }> = ({
  children,
  header,
}) => {
  const [isLogin, setIsLogin] = useState(false);

  return (
    <div className="layout">
      <div
        className={
          isLogin
            ? "layout-container"
            : "layout-container layout-container-margin"
        }
      >
        {header}
        {children}
      </div>
    </div>
  );
};

export default observer(SJLayout);
